export const FIELD_ID = {
  ticket: {
    category: 121174,
    subcategory: 121176,
  },
}
